var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 15.6495H13V17.6495H11V15.6495ZM11 7.64954H13V13.6495H11V7.64954ZM11.99 2.64954C6.47 2.64954 2 7.12954 2 12.6495C2 18.1695 6.47 22.6495 11.99 22.6495C17.52 22.6495 22 18.1695 22 12.6495C22 7.12954 17.52 2.64954 11.99 2.64954ZM12 20.6495C7.58 20.6495 4 17.0695 4 12.6495C4 8.22954 7.58 4.64954 12 4.64954C16.42 4.64954 20 8.22954 20 12.6495C20 17.0695 16.42 20.6495 12 20.6495Z",
    fill: "#CE7309"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertOrange);
export default __webpack_public_path__ + "static/media/alert-orange.034fb4f78f6d48fec82bb62be8e743cd.svg";
export { ForwardRef as ReactComponent };